/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum NotificationTimeFormat {
  TWELVE_HOUR="TWELVE_HOUR",
MILITARY="MILITARY"
}

/**
* NotificationTimeFormat
*/
export const NotificationTimeFormatEnumType = types.enumeration("NotificationTimeFormat", [
        "TWELVE_HOUR",
  "MILITARY",
      ])
